import React from 'react';
import { PATH } from 'common/constants';
import type { NotificationOut } from 'service/notificationsService';
import { GenericNotification } from './renderers/GenericNotification';

type BaseNotification = NotificationOut;

export type SurveyLoadPayload = {
  survey_name?: string | null;
};

export type SurveyLoadSuccessNotification = BaseNotification & {
  type: 'survey.load_success';
  payload: SurveyLoadPayload;
};

export type SurveyLoadPausedNotification = BaseNotification & {
  type: 'survey.load_paused';
  payload: SurveyLoadPayload;
};

type SurveyNotification = SurveyLoadSuccessNotification | SurveyLoadPausedNotification;
type SurveyRenderers = { [N in SurveyNotification as N['type']]: (n: N) => React.ReactNode };

export const surveyRenderers: SurveyRenderers = {
  'survey.load_success': (n) => (
    <GenericNotification
      title='Survey available'
      description={`${n.payload?.survey_name ?? 'Survey'} is now available.`}
      link={{ text: 'View survey', link: PATH.TABLE_SURVEYS }}
      tag={{ color: 'success', children: 'Available' }}
    />
  ),
  'survey.load_paused': (n) => (
    <GenericNotification
      title="Survey under review"
      description={`${n.payload?.survey_name ?? 'Survey'} is under review.`}
      tag={{ color: 'warning', children: 'In Review' }}
    />
  ),
};
